import { Loader } from "../Loader/Loader";
import "./LoadingPanel.css";

const LoadingPanel = () => {
  return (
    <div className="loading">
      <Loader />
    </div>
  );
};

export { LoadingPanel };
